import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    settings: state.context.settings,
    featurePages: state.context.session.properties.featurePages,
    isSecurityRolesAssigned: state.context.session?.properties?.isSecurityRolesAssigned?.toLowerCase() === "true",
});

export interface ItemTrackingImportContainerStyles {
    container?: GridContainerProps;
    fileUploadGridItem?: GridItemProps;
    instructionsGridItem?: GridItemProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
}

export const ItemTrackingImportContainerStyles: ItemTrackingImportContainerStyles = {
    fileUploadGridItem: { width: [12, 12, 12, 12, 12] },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 20px;
        `,
    },
    noResultsText: {
        variant: "h4",
    },
};

const styles = ItemTrackingImportContainerStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const ItemTrackingImportContainer: FC<Props> = ({ featurePages, isSecurityRolesAssigned, id }: Props) => {
    if (featurePages?.includes("Item Tracking Upload")) {
        return (
            <StyledWrapper {...styles.noResultsContainer}>
                <Typography as="p" {...styles.noResultsText} data-test-selector="no-access-message">
                    {translate(`You don’t have permission to view this page`)}
                </Typography>
            </StyledWrapper>
        );
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.fileUploadGridItem}>
                <Zone zoneName="Content00" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ItemTrackingImportContainer),
    definition: {
        group: "Basic",

        displayName: "Item Tracking Import Container",
    },
};

export default widgetModule;
